import React, {useEffect, useState} from 'react';
import { Container, Form} from "react-bootstrap";
import {CustomButton, TabBar, TabItem} from "../components";
import NextIcon from "../assets/next-icon";
import {ActiveCircleIcon, CircleCheckICon} from "../assets";
import CircleEmptyIcon from "../assets/circle-empty-icon";
import {PATH_APP, PATH_AUTH} from "../routes/paths";
import {Picker} from "react-mobile-style-picker";
import 'react-mobile-style-picker/dist/index.css'
import range from "../utils/range";
import useIsMountedRef from "../hooks/useIsMountedRef";
import {useForm} from "react-hook-form";
import {FormProvider} from "../components/hook-form";
import {useNavigate} from "react-router";
import {Link} from "react-router-dom";
import BackIcon from "../assets/back-icon";

let heightList = range(100, 200)
let weightListKiloGrams = range(20, 180)
let weightListGrams = [ 0 , 100 , 200 , 300 , 400 , 500 , 600 , 700 , 800 , 900]


function UserInfo() {
    const isMountedRef = useIsMountedRef();


    const methods = useForm();
    const navigate = useNavigate();

    const {
        reset,
        register,
        setError,
        handleSubmit,
        clearErrors,
        formState: {errors, isSubmitting},
    } = methods;
    const onSubmit = async (data) => {
        try {
            localStorage.setItem('height', height)
            localStorage.setItem('weight', weightKiloGrams + "." +weightGrams)
            localStorage.setItem('gender', gender)
            localStorage.setItem('body_information', JSON.stringify(data))
             navigate(PATH_APP.activity)
        } catch (error) {
            reset();

        }

    };
    const [height, setHeight] = useState(150);
    const [weightKiloGrams, setWeightKiloGrams] = useState(60);
    const [weightGrams, setWeightGrams] = useState(500);
    const [gender, setGender] = useState('male');
    return (
        <div id="information-page">
            <header className="fixed-top"
                    style={{backdropFilter: "blur(6px)", backgroundColor: "rgb(255 255 255 / 50%)"}}>
                <h6 className="text-center p-4 mb-0">
                    <Link to={PATH_AUTH.login} className="float-end">
                        <BackIcon/>
                    </Link>
                    اطلاعات بدن</h6>
            </header>
            <header className="d-flex justify-content-between align-items-center">
                <Container style={{paddingRight: "0", paddingLeft: "0", marginTop: "88px"}}>
                    <TabBar>
                        <div>
                            <TabItem href="#"
                                     icon={<CircleCheckICon/>}
                                     title="اطلاعات شخصی"/>
                        </div>
                        <div>
                            <div style={{borderTop: "3px dotted #37C26F", width: "15px"}}/>
                        </div>
                        <div>
                            <TabItem href="#"
                                     icon={<ActiveCircleIcon fill1="#21242F" fill2="#37C26F" stroke="#37C26F"/>}
                                     title="اطلاعات بدن"/>
                        </div>
                        <div>
                            <div style={{borderTop: "3px dotted #434857", width: "15px"}}/>
                        </div>
                        <div>
                            <TabItem href="#"
                                     icon={<CircleEmptyIcon fill="#21242F" stroke="#525767"/>} title="نوع برنامه"/>
                        </div>
                        <div>
                            <div style={{borderTop: "3px dotted #434857", width: "15px"}}/>
                        </div>
                        <div>
                            <TabItem href="#"
                                     icon={<CircleEmptyIcon fill="#21242F" stroke="#525767"/>} title="سابقه بیماری"/>
                        </div>
                    </TabBar>
                </Container>
            </header>
            <Container style={{marginTop:"60px" , marginBottom:"20px"}}>
                <>
                    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
                        <Container style={{paddingBottom:"80px"}}>
                            <div className="height-box">
                                <div className="d-flex justify-content-between height-box-header">
                                    <h2>قد (سانتیمتر)</h2>
                                    <span>{height}</span>
                                </div>
                                <div className="swipe-picker-wrapper">
                                    <div className="swipe-picker" dir="ltr">
                                        <Picker mode="horizontal" value={height} smooth={true}
                                                onChange={(data) => {
                                                    setHeight(data)
                                                }}
                                                scrollSelect={true} dragSelect={true}
                                                clickSelect={true} size={5} rotate={false}>
                                            {
                                                heightList.map(function (value) {
                                                    return (<Picker.Item value={value}>{value}</Picker.Item>)
                                                })
                                            }

                                        </Picker>
                                    </div>

                                </div>
                            </div>
                            <div className="height-box">
                                <div className="d-flex justify-content-between height-box-header">
                                    <h2 className="mb-0">وزن (کیلوگرم)</h2>
                                    <span>{weightKiloGrams + "." + weightGrams}</span>
                                </div>

                                <div className="swipe-picker" dir="ltr">
                                    <Picker mode="horizontal" value={weightKiloGrams} {...register('weight')} smooth={true}
                                            onChange={(data) => {
                                                setWeightKiloGrams(data)
                                            }}
                                            scrollSelect={false} dragSelect={true}
                                            clickSelect={true} size={5} rotate={false}>
                                        {
                                            weightListKiloGrams.map(function (value) {
                                                return (<Picker.Item value={value}>{value}</Picker.Item>)
                                            })
                                        }

                                    </Picker>
                                </div>
                                <div className="d-flex justify-content-between height-box-header">
                                    <h2 className="mb-0 mt-2">
                                        وزن (گرم)</h2>
                                </div>

                                <div className="swipe-picker" dir="ltr">
                                    <Picker mode="horizontal" value={weightGrams} {...register('weight')} smooth={true}
                                            onChange={(data) => {
                                                setWeightGrams(data)
                                            }}
                                            scrollSelect={false} dragSelect={true}
                                            clickSelect={true} size={5} rotate={false}>
                                        {
                                            weightListGrams.map(function (value) {
                                                return (<Picker.Item value={value}>{value}</Picker.Item>)
                                            })
                                        }

                                    </Picker>
                                </div>
                            </div>
                            <div className="swipe-picker gender-picker mt-3 d-flex align-items-center bg-white"
                                 dir="ltr">
                                <Picker mode="horizontal" smooth={true} value={gender} scrollSelect={true}
                                        dragSelect={true}
                                        size={2} onChange={(data) => {
                                    setGender(data)
                                }}
                                        clickSelect={true}>
                                    <Picker.Item value="male">مرد</Picker.Item>
                                    <Picker.Item value="female">زن</Picker.Item>

                                </Picker>
                                <span className="mx-3">جنسیت</span>

                            </div>
                            <div className="mt-4 user-information-footer">

                                <Form.Check {...register('has_experience')}
                                            type="switch"
                                            className="custom-switch"
                                            label="تجربه کاهش وزن داشته ام"
                                />
                                <hr/>
                                <Form.Check {...register('can_exercise')}
                                            type="switch"
                                            className="custom-switch"
                                            label="امکان ورزش کردن دارم"

                                />
                                <hr/>
                                <Form.Check {...register('has_fat_family')}
                                            type="switch"
                                            className="custom-switch"
                                            label="اطرافیان دچار اضافه وزن دارم."

                                />
                            </div>
                        </Container>
                        <footer className="fixed-bottom" style={{marginTop:"25px" , background:"#fff" , boxShadow:"1px -11px 12px 1px #2725251c" , borderRadius:"15px 15px 0 0" , padding:"15px" , backdropFilter:"blur(6px)" , backgroundColor:"rgb(234 234 234 / 50%)"}}>
                            <CustomButton>
                                <NextIcon/>
                                <span> مرحله بعدی</span>
                            </CustomButton>
                        </footer>
                    </FormProvider>
                </>
            </Container>
        </div>
    )
        ;
}

export default UserInfo;
